module.exports = __webpack_public_path__ + "static/media/Tile Image 1.5912f15a.png";